import bciLogo from '/public/images/contact-us/BCI_2025Logo_Vertical_FullColor.png';
import beiLogo from '/public/images/contact-us/BEI_2025Logo_Horizontal_FullColor.png';
import mkdLogo from '/public/images/contact-us/MKD LOGO.png';
import seaTacLogo from '/public/images/contact-us/SEATAC_Logo_Color.png';
import jsetLogo from '/public/images/contact-us/JSET_Logo.png';
import dlElectricLogo from '/public/images/contact-us/DLElectric_2025Logo_FullColor.png';
import xsTelecomLogo from '/public/images/contact-us/XSTelecom_2025Logo_Black.png';
import wesaLogo from '/public/images/contact-us/Wesa Automation Logo.png';
import powerCorLogo from '/public/images/contact-us/Powercor_Logo.png';

export const businessInfo = {
  'Brittain Electric': {
    name: 'Brittain Electric',
    address1: '55 Oxford Business Parkway',
    address2: 'Suite A',
    cityStateZip: 'Oxford, GA 30054',
    country: '',
    email: '',
    phone: '',
    website: 'https://brittainelectric.net/',
    logo: beiLogo,
    pinTop: '60%',
    pinLeft: '75%',
    pinColor: 'dark',
    logoPositionInDiv: 'right',
    motto: 'Providing the Highest Quality Electrical Services',
    about:
      'Brittain Electric specializes in electrical systems for commercial or government facilities and is committed to bringing the most reliable electrical services and systems to meet your needs. Our services include commercial lighting, new construction, generators, power distribution systems, exterior lighting, general electrical installations and more.',
  },
  'MKD Electric': {
    name: 'MKD Electric',
    address1: '2590 Alft Ln, Unit A',
    address2: '',
    cityStateZip: 'Elgin, IL 60124',
    country: '',
    email: '',
    phone: '',
    website: 'https://www.mkdelectric.com/',
    logo: mkdLogo,
    pinTop: '33%',
    pinLeft: '64%',
    pinColor: 'dark',
    logoPositionInDiv: '',
    motto: 'Full-Service Industrial Electrical Contracting',
    about:
      'As a full service electrical, instrumentation and systems integration contractor, MKD Electric designs, builds, installs and maintains electrical systems in industrial environments, including chemical, petrochemical, distribution and packaging. We strive to deliver the highest quality service, safety and performance on projects large or small.',
  },
  'JSET Automated Technologies': {
    name: 'JSET Automated Technologies',
    address1: '1900 Jetway Blvd',
    address2: '',
    cityStateZip: 'Columbus, OH 43219',
    country: '',
    email: 'info@jset.tech',
    phone: '(855) 700-JSET (5738)',
    website: 'https://jset.tech/',
    logo: jsetLogo,
    pinTop: '35%',
    pinLeft: '74%',
    pinColor: '',
    logoPositionInDiv: 'right',
    motto: 'Best-in-Class Building Automation',
    about:
      'For over 50 years, JSET Automated Technologies has specialized in developing control systems for industrial motor controls and commercial HVAC systems. We focus on data centers, building automation systems and precise PLC microprocessor installations and repairs, ensuring our solutions are tailored to meet the demands of modern industries.',
  },
  'SeaTac Electric': {
    name: 'SeaTac Electric',
    address1: '1105 Porter Way',
    address2: '',
    cityStateZip: 'Milton, WA 98354',
    country: '',
    email: '',
    phone: '',
    website: 'https://seatacelectric.com/',
    logo: seaTacLogo,
    pinTop: '8%',
    pinLeft: '7.5%',
    pinColor: '',
    logoPositionInDiv: 'left',
    motto: 'Innovating Electrical Design, Safety and Quality',
    about:
      'Sea-Tac is a full-service electrical company offering electrical design, construction and services. Our expertise includes electrical design engineering, new commercial building electrical design-build construction, electrical repairs, voice and data structured cabling systems, and security systems for commercial properties.',
  },
  'XS Telecom': {
    name: 'XS Telecom',
    address1: '22821 Silverbrook Center Drive',
    address2: 'Unit 120',
    cityStateZip: 'Sterling, VA 20166',
    country: '',
    email: '',
    phone: '',
    website: 'https://xstele.com/va/',
    logo: xsTelecomLogo,
    pinTop: '40%',
    pinLeft: '82%',
    pinColor: 'dark',
    logoPositionInDiv: '',
    motto: 'Global Specialist in Voice and Data',
    about:
      'Based in the Washington, D.C. region, XS Telecom is a leading cabling contractor and provider of data system installation services. We serve small to large enterprises in the public sector, offering a one-stop shop for design, development, installation, programming and support.',
  },
  'D&L Electric': {
    name: 'D&L Electric',
    address1: '55 Oxford Business Parkway',
    address2: 'Suite B',
    cityStateZip: 'Oxford, GA 30054',
    country: '',
    email: '',
    phone: '',
    website: 'https://dlelectricinc.net/',
    logo: dlElectricLogo,
    pinTop: '61%',
    pinLeft: '77%',
    pinColor: '',
    logoPositionInDiv: 'right',
    motto: 'Commercial and Industrial Electrical Contracting',
    about:
      'D&L Electric is a commercial and industrial electrical contractor, providing exemplary quality and service to clients since 2003. We offer specialized electrical solutions for retail, tenant build-outs, healthcare facilities, distribution centers and manufacturing plants. Our service offerings include lighting upgrades and electrical service and upgrades.',
  },
  'WESA Automation': {
    name: 'WESA Automation',
    address1: '2590 Alft Lane, Unit A',
    address2: '',
    cityStateZip: 'Elgin, IL 60124',
    country: '',
    email: '',
    phone: '',
    website: 'https://www.wesaautomation.com/',
    logo: wesaLogo,
    pinTop: '35%',
    pinLeft: '63%',
    pinColor: '',
    logoPositionInDiv: '',
    motto: 'Precision Controls Integration',
    about:
      'Wesa Automation provides state-of-the-art engineering, automation and controls integration solutions for manufacturing and industrial applications. Our services include controls engineering, design, programming, control panel fabrication, installation and systems commissioning services for PLC panels, variable speed drives, motion control and more.',
  },
  Powercor: {
    name: 'Powercor',
    address1: '22821 Silverbrook Center Dr',
    address2: 'Suite 120',
    cityStateZip: 'Sterling, VA 20166',
    country: '',
    email: '',
    phone: '',
    website: 'https://powercor.com/',
    logo: powerCorLogo,
    pinTop: '40%',
    pinLeft: '84%',
    pinColor: 'light',
    logoPositionInDiv: '',
    motto: 'Providing Electric Testing and Electric Power Systems',
    about:
      'Powercor is an independent, NICET-certified electrical testing and engineering organization with experience in manufacturing, data centers, healthcare, defense and more. Our services include electrical testing, system design, electrical engineering, systems integration, commissioning, equipment servicing and retrofit services.',
  },
  'Bachelor Controls, Inc': {
    name: 'Bachelor Controls, Inc',
    address1: '10417 W 84th Terrace',
    address2: '',
    cityStateZip: 'Lenexa, KS 66214',
    country: '',
    email: '',
    phone: '(785) 284-3482',
    website: 'https://www.bachelorcontrols.com/',
    logo: bciLogo,
    pinTop: '45%',
    pinLeft: '50%',
    pinColor: '',
    logoPositionInDiv: 'right',
    motto: 'Industry Leading Integration Solutions',
    about:
      'BCI is a leading provider of control and systems integration solutions in various manufacturing sectors, including food and beverage, petfood, pharmaceutical, plastics, specialty chemicals, and feed and grain. Our specialties include high-end batching systems, automated cooking extrusion, food and ingredient processes, bulk material transport and material handling. ',
  },
  'Industria Power + Data': {
    name: 'Industria Power + Data',
    address1: '2590 Alft Lane, Unit A',
    address2: '',
    cityStateZip: 'Elgin, IL 60124',
    country: 'United States',
    email: 'info@industriapowerdata.com',
    phone: '',
    website: 'https://www.industriapowerdata.com/',
    logo: '/images/contact-us/Industria_Logo_FullColor_RGB 1.png',
    pinTop: '37%',
    pinLeft: '63%',
    pinColor: 'dark',
    logoPosition: 'right',
    motto:
      'Expertise in electrical contracting, systems integration and infrastructure services for the industrial and commercial industries.',
    about: '',
  },
};

export const ServicesOverview = [
  {
    service: 'commercial lighting',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_CommercialLighting.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'power distribution',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_PowerDistribution.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'generators',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_Generators.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'Custom Lighting',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_CustomLighting.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'Parking Lot & Exterior Lighting',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_ParkingLotExteriorLighting.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'General Electrical',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_GeneralElectrical.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'New Construction',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_NewConstruction.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'Data Centers',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_DataCenters.png',
    imageWidth: 202,
    imageHeight: 185,
  },
  {
    service: 'EV Charging',
    imageSource: '/images/homepage/Industria_Websites-Brittain_Icons_EVCharging.png',
    imageWidth: 202,
    imageHeight: 185,
  },
];

export const NavBarRoutes = [
  {
    label: 'Services',
    href: '',
    hasSubLinks: true,
    subLinks: [
      {
        label: 'Commercial Lighting',
        href: '/services/commercial-lighting',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'New Construction',
        href: '/services/new-construction',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'Generators',
        href: '/services/generators',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'Power Distribution',
        href: '/services/power-distribution',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'Custom Lighting',
        href: '/services/custom-lighting',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'Parking Lot & Exterior Lighting',
        href: '/services/parking-lot-and-exterior-lighting',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'General Electrical',
        href: '/services/general-electrical',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'Data Centers',
        href: '/services/data-centers',
        hasSubLinks: false,
        subLinks: [],
      },
      {
        label: 'EV Charging',
        href: '/services/ev-charging',
        hasSubLinks: false,
        subLinks: [],
      },
    ],
  },
  {
    label: 'Projects',
    href: '/projects',
    hasSubLinks: false,
    subLinks: [],
  },
  {
    label: 'About',
    href: '/about',
    hasSubLinks: false,
    subLinks: [
      {
        label: 'Certifications',
        href: '/about/certifications',
        hasSubLinks: false,
        subLinks: [],
      },
    ],
  },
  {
    label: 'Contact Us',
    href: '/contact-us',
    hasSubLinks: false,
    subLinks: [],
  },
  { label: 'Careers', href: '/careers', hasSubLinks: false, subLinks: [] },
];
